module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/246-india-e1482d2442bfc696b353a06feb0a9918.svg";